import withStickyBehaviorSearch from './withStickyBehaviorSearch';

import ConsumerHeader from './ConsumerHeader';

export default withStickyBehaviorSearch(ConsumerHeader);
